// extracted by mini-css-extract-plugin
export default {"page":"jR","headerwrap":"kR","headerblock":"lR","textwrapper":"mR","text":"nR","closerlook":"oR","arrowwrap":"pR","icon":"qR","updown":"rR","products":"sR","system":"tR","systemimage":"uR","cards":"vR","note":"wR","fadein":"xR"};
    if(module.hot) {
      // 1713211523599
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  